module.exports = __webpack_public_path__ + "media/images/category/experiences-21415486c67427805590b2bfb71b1285.svg";